var r=function(r){var n=Object.keys(r).sort((function(r,n){return r.localeCompare(n)})).reduce((function(n,e){return n[e]=r[e],n}),{});return JSON.stringify(n)},n=function(r){return JSON.parse(r)};export{n as getItem,r as getItemId};
